import React from "react";

const UserGroupListSkelton = ({ forGroup = true, number = 1 }) => {
  return (
    <>
      <div className="groupusertab">
        <div className="groupusercont">
          <div className="user-tab-content">
            {Array.from({ length: number }).map((e) => {
              return (
                <div className="d-flex align-items-center gap-2 mb-2">
                  <div className="d-flex align-items-center gap-1 w-100">
                    <div className="skeleton skeleton-avatar" />
                    <div className="d-flex justify-content-between w-100 pr-2">
                      <div>
                        <div className="skeleton" style={{ width: "9rem", height: "1rem" }} />
                        {forGroup && (
                          <div className="skeleton" style={{ width: "6rem", height: ".7rem", marginTop: ".4rem" }} />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default UserGroupListSkelton;
